import { render, staticRenderFns } from "./cardHeader.vue?vue&type=template&id=4bbe9cce&scoped=true"
import script from "./cardHeader.vue?vue&type=script&lang=js"
export * from "./cardHeader.vue?vue&type=script&lang=js"
import style0 from "./cardHeader.vue?vue&type=style&index=0&id=4bbe9cce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe9cce",
  null
  
)

export default component.exports